import React, { useState } from 'react';
const SAMPLE_LISTS = [
  { id: 1, name: 'Weekly Groceries', items: 18, checked: 12, total: 142.50, updated: '2 hours ago' },
  { id: 2, name: 'Party Supplies', items: 8, checked: 0, total: 64.20, updated: '1 day ago' },
  { id: 3, name: 'Meal Prep Sunday', items: 14, checked: 14, total: 98.40, updated: '3 days ago' },
];
const ITEMS = [
  { name: 'Organic Milk (1 gal)', qty: 2, price: 5.99, aisle: 'Dairy - Aisle 3', checked: true },
  { name: 'Whole Wheat Bread', qty: 1, price: 4.49, aisle: 'Bakery', checked: true },
  { name: 'Chicken Breast (2 lb)', qty: 1, price: 12.99, aisle: 'Meat - Aisle 8', checked: true },
  { name: 'Bananas (bunch)', qty: 1, price: 1.49, aisle: 'Produce', checked: true },
  { name: 'Roma Tomatoes (lb)', qty: 2, price: 2.99, aisle: 'Produce', checked: false },
  { name: 'Cheddar Cheese', qty: 1, price: 6.49, aisle: 'Dairy - Aisle 3', checked: false },
  { name: 'Pasta (box)', qty: 3, price: 1.99, aisle: 'Aisle 5', checked: false },
  { name: 'Olive Oil', qty: 1, price: 8.99, aisle: 'Aisle 5', checked: false },
  { name: 'Greek Yogurt', qty: 4, price: 1.29, aisle: 'Dairy - Aisle 3', checked: false },
  { name: 'Eggs (dozen)', qty: 1, price: 4.99, aisle: 'Dairy - Aisle 3', checked: false },
];
export default function ShoppingListPage() {
  const [items, setItems] = useState(ITEMS);
  const checked = items.filter(i => i.checked).length;
  const total = items.reduce((a, i) => a + (i.price * i.qty), 0);
  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <div><h1 style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>Shopping Lists</h1><p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>Customer shopping lists with aisle routing</p></div>
        <button style={{ padding: '10px 20px', background: 'var(--primary)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>+ New List</button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16, marginBottom: 24 }}>
        {SAMPLE_LISTS.map(l => (
          <div key={l.id} style={{ padding: 20, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', cursor: 'pointer' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <span style={{ color: 'var(--text)', fontSize: 15, fontWeight: 700 }}>{l.name}</span>
              <span style={{ color: 'var(--text-muted)', fontSize: 11 }}>{l.updated}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <div style={{ flex: 1, height: 6, background: 'var(--border)', borderRadius: 3, overflow: 'hidden' }}>
                <div style={{ width: `${(l.checked / l.items) * 100}%`, height: '100%', background: l.checked === l.items ? '#16A34A' : 'var(--primary)', borderRadius: 3 }} />
              </div>
              <span style={{ color: 'var(--text-muted)', fontSize: 11 }}>{l.checked}/{l.items}</span>
            </div>
            <div style={{ color: '#16A34A', fontSize: 14, fontWeight: 700 }}>Est. ${l.total.toFixed(2)}</div>
          </div>
        ))}
      </div>
      <div style={{ background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', padding: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div>
            <div style={{ color: 'var(--text)', fontSize: 16, fontWeight: 700 }}>Weekly Groceries</div>
            <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>{checked}/{items.length} items checked — Est. ${total.toFixed(2)}</div>
          </div>
        </div>
        {items.map((item, idx) => (
          <div key={idx} onClick={() => { const n = [...items]; n[idx] = { ...n[idx], checked: !n[idx].checked }; setItems(n); }} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 0', borderBottom: '1px solid var(--border)', cursor: 'pointer' }}>
            <div style={{ width: 22, height: 22, borderRadius: 6, border: `2px solid ${item.checked ? '#16A34A' : 'var(--border)'}`, background: item.checked ? '#16A34A' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 12, fontWeight: 700, flexShrink: 0 }}>{item.checked ? '\u2713' : ''}</div>
            <div style={{ flex: 1 }}>
              <div style={{ color: item.checked ? 'var(--text-muted)' : 'var(--text)', fontSize: 13, fontWeight: 600, textDecoration: item.checked ? 'line-through' : 'none' }}>{item.name}</div>
              <div style={{ color: 'var(--text-muted)', fontSize: 11 }}>{item.aisle}</div>
            </div>
            <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>x{item.qty}</div>
            <div style={{ color: item.checked ? 'var(--text-muted)' : '#16A34A', fontSize: 13, fontWeight: 600 }}>${(item.price * item.qty).toFixed(2)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
